<div class="container py-4">
  <h1 class="mb-4">Data Deletion Request</h1>

  <p>
    If you would like to request the deletion of your personal data held by PlateX, please send an email to
    <a href="mailto:hugh@platex.co.uk">hugh@platex.co.uk</a> with the subject line:
  </p>
  <p><strong>"Data Deletion Request – [your registered email address]"</strong></p>

  <p>In your email, please include:</p>
  <ul>
    <li>Your full name.</li>
    <li>The email address associated with your PlateX account.</li>
    <li>Any additional details that will help us identify your account (e.g., username or order reference).</li>
  </ul>

  <p>
    We will acknowledge your request within 5 working days and complete the deletion within 30 days, in
    accordance with applicable data protection law.
  </p>

  <p>
    <strong>Social login users:</strong> If you registered or signed in using Google or Facebook, deleting your
    PlateX account will remove all data we hold about you. It will not affect your Google or Facebook account.
    To revoke PlateX's access to your social profile, visit the connected apps settings in your Google or
    Facebook account.
  </p>

  <p>
    For any other privacy-related queries, please review our
    <a href="/privacy-policy">Privacy Policy</a> or contact us at
    <a href="mailto:hugh@platex.co.uk">hugh@platex.co.uk</a>.
  </p>
</div>
